import 'jquery'
import 'signalR'
export default{
  SR:{},
  initSG:function () {
    this.SR = $.hubConnection(SZH.assets.ws, {});
    // this.SR.proxyMy = this.SR.createHubProxy("NoticeHub");
    // this.SR.start().done((connection) => {
    //   console.log("signaR连接成功");
    // }).fail((data) => {
    // });
  }
}



// WEBPACK FOOTER //
// ./src/api/singal.js